/**
 * Created by staffanrantzow on 16/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import styles from './SpinnerButton.scss';

export class SpinnerButton extends React.Component {

  static propTypes = {
    text: PropTypes.string.isRequired,
    classes: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    callback: PropTypes.func,
    graySpinner: PropTypes.string,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    id: PropTypes.string
  };

  constructor (props) {
    super(props);
    this.callCallback = this.callCallback.bind(this);
  }

  callCallback (e) {
    if (!this.props.loading && typeof this.props.callback === 'function') {
      this.props.callback(e);
    }
  }

  render () {
    var classes = this.props.classes + ' ' + styles.spinnerButton;

    if (this.props.loading) {
      classes += ' ' + styles.show;
    }

    if (this.props.graySpinner === 'true') {
      classes += ' ' + styles.spinnerButtonGray;
    }

    return (
      <button id={this.props.id} type={(this.props.type) ? this.props.type : 'submit'}
        className={classes}
        onClick={this.callCallback}
        disabled={this.props.disabled}>
        <span id='spinner-text' className={styles.spinnerText}>{this.props.text}</span>
        <span id='spinner-element' className={styles.spinnerElement}>
          <span className={styles.spinner}></span>
        </span>
      </button>
    );
  }
}

export default SpinnerButton;




/** WEBPACK FOOTER **
 ** ./src/components/spinner-button/spinner-button.js
 **/